<template>
<div class="chapter">
<div class="inner_page">
<div id="TOC.html" xml:lang="en-US">
<div class="story">
<p class="TOCtitle">Table of Contents</p>
<p class="TOCitem"><a href="#/On_a_Winters_Eve#Anchor-1">ON A WINTER’S EVE by Louise Allen</a></p>
<p class="TOCitem"><span href="#/Marriage_Made_at_Christmas_of_book_2#Anchor-1" title="Link target outside of Sample">MARRIAGE MADE AT CHRISTMAS by Sophia James</span></p>
<p class="TOCitem"><span href="#/Cinderellas_Perfect_Christmas_of_book_3#Anchor-1" title="Link target outside of Sample">CINDERELLA’S PERFECT CHRISTMAS by Annie Burrows</span></p>
<p class="TOCitem"><span href="#/Excerpt_of_book_3#Anchor-1" title="Link target outside of Sample">Excerpt from <em>Unwrapping the Rancher’s Secret</em> by Lauri Robinson</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?3bf74763